import React from "react";
import PropTypes from "prop-types";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { SFArrowDownIcon } from "../icons";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

export const SFAccordionDetails = (props) => {
  return <AccordionDetails {...props}>{props.children}</AccordionDetails>;
};

SFAccordionDetails.propTypes = {
  children: PropTypes.node,
};


const StyledAccordionSummary = styled(AccordionSummary)(({ theme, reverse }) => ({
  ...(reverse && {
    flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIconWrapper": {
      marginRight: "auto", 
      marginLeft: 0, 
    },
  }),
}));

export const SFAccordionSummary = ({
  children,
  iconColor,
  expandIcon,
  expandClickIconOnly = true,
  reverse = false,
  sx,
  ...props
}) => {
  return (
    <StyledAccordionSummary
      expandIcon={expandIcon ?? <SFArrowDownIcon />}
      reverse={reverse}
      sx={{
        "& .MuiAccordionSummary-expandIconWrapper svg": {
          color: iconColor,
          ...(expandClickIconOnly && { pointerEvents: "auto" }),
        },
        ...(expandClickIconOnly && { pointerEvents: "none" }),
        ...sx,
      }}
      {...props}
    >
      {children}
    </StyledAccordionSummary>
  );
};

SFAccordionSummary.propTypes = {
  children: PropTypes.node,
  iconColor: PropTypes.string,
  expandIcon: PropTypes.node,
  expandClickIconOnly: PropTypes.bool,
  reverse: PropTypes.bool, // Add the reverse prop type
};

const SFAccordion = ({ expanded, children, disabled, onChange, ...props }) => {
  return (
    <Accordion
      sx={{
        boxShadow: "none",
        ":before": {
          display: "none",
        },
        ...props.sx,
      }}
      expanded={expanded}
      disabled={disabled}
      onChange={onChange}
      {...props}
    >
      {children}
    </Accordion>
  );
};

SFAccordion.propTypes = {
  children: PropTypes.node,
  onChange: PropTypes.func,
  expanded: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default SFAccordion;